import sanityClient from 'utilities/client';
import fetchData from 'utilities/fetchData';

const getPhone = async () => await sanityClient.fetch([`*[ _type == "phone"]`]);

const getPhoneData = fetchData(getPhone, '');

export { getPhoneData };
